<nz-modal
    nzClassName="cb4-assignment-modal cb4-task-browser-modal"
    [nzStyle]="{ top: '5vh' }"
    [nzVisible]="state.isOpen"
    [nzTitle]="modalTitle"
    [nzWidth]="'min(1100px, calc(100vw - 24px))'"
    [nzBodyStyle]="bodyStyle"
    [nzFooter]="null"
    [nzKeyboard]="!isEvidenceModalOpen"
    (nzOnCancel)="close()"
>
    <ng-container *nzModalContent>
        <div class="task-browser">
            <ng-container *ngIf="(!activeLoading || hasLoadedInitialPage) && !state.filters.taskId">
            <div class="task-browser__toolbar" [class.task-browser__toolbar--filters]="filtersVisible">
            <div *ngIf="filtersVisible" class="task-browser__filters"
                [class.task-browser__filters--three]="state.context?.kind === 'header' || state.context?.kind === 'assessment'"
                role="group" [attr.aria-label]="isCombinedHeader ? 'Filter assigned work' : 'Filter tasks'">
                <div class="task-browser__filter task-browser__filter--search">
                    <input
                        id="task-browser-search"
                        [attr.aria-label]="isCombinedHeader ? 'Search assigned work' : 'Search tasks'"
                        type="search"
                        [ngModel]="searchText"
                        (ngModelChange)="changeTextSearch($event)"
                        maxlength="200"
                        [placeholder]="isCombinedHeader ? 'Search assigned work' : 'Search by task, comment, or control'"
                    />
                </div>

                <div *ngIf="state.context?.kind !== 'header'" class="task-browser__filter">
                    <nz-select
                        id="task-browser-assignees"
                        aria-label="Assigned users"
                        class="task-browser__select"
                        nzDropdownClassName="task-browser__select-dropdown"
                        nzMode="multiple"
                        [nzMaxTagCount]="1"
                        nzShowSearch
                        nzServerSearch
                        nzAllowClear
                        [nzPlaceHolder]="state.filters.assignedToMe ? 'Assigned to me' : 'Filter by assigned user'"
                        [nzLoading]="assigneeOptions.loading"
                        [ngModel]="selectedAssigneeIds"
                        (ngModelChange)="changeAssignees($event)"
                        (nzOnSearch)="searchAssignees($event)"
                        (nzOpenChange)="openAssignees($event)"
                        (nzScrollToBottom)="moreAssignees()"
                    >
                        <nz-option *ngFor="let option of displayedAssignees; trackBy: trackChoice"
                            [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
                    </nz-select>
                    <span *ngIf="assigneeOptions.error" class="task-browser__filter-error" role="alert">
                        {{ assigneeOptions.error }}
                        <button nz-button nzType="link" type="button" (click)="openAssignees(true)">Retry</button>
                    </span>
                </div>

                <div *ngIf="state.context?.kind !== 'assessment'" class="task-browser__filter">
                    <nz-select
                        id="task-browser-assessments"
                        aria-label="Assessments"
                        class="task-browser__select"
                        nzDropdownClassName="task-browser__select-dropdown"
                        nzMode="multiple"
                        [nzMaxTagCount]="1"
                        nzShowSearch
                        nzServerSearch
                        nzAllowClear
                        nzPlaceHolder="Filter by assessment"
                        [nzLoading]="assessmentOptions.loading"
                        [ngModel]="activeFilters.assessmentIds || emptyIds"
                        (ngModelChange)="changeAssessments($event)"
                        (nzOnSearch)="searchAssessments($event)"
                        (nzOpenChange)="openAssessments($event)"
                        (nzScrollToBottom)="moreAssessments()"
                    >
                        <nz-option *ngFor="let option of displayedAssessments; trackBy: trackChoice"
                            [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
                    </nz-select>
                    <span *ngIf="assessmentOptions.error" class="task-browser__filter-error" role="alert">
                        {{ assessmentOptions.error }}
                        <button nz-button nzType="link" type="button" (click)="openAssessments(true)">Retry</button>
                    </span>
                </div>

                <div class="task-browser__filter">
                    <nz-select
                        id="task-browser-statuses"
                        aria-label="Statuses"
                        class="task-browser__select"
                        nzDropdownClassName="task-browser__select-dropdown"
                        nzMode="multiple"
                        [nzMaxTagCount]="1"
                        nzShowSearch
                        nzAllowClear
                        [nzPlaceHolder]="isCombinedHeader ? 'Filter by status' : 'Filter by task status'"
                        [nzLoading]="statusOptions.loading"
                        [ngModel]="activeFilters.statuses || emptyStatuses"
                        (ngModelChange)="changeStatuses($event)"
                        (nzOpenChange)="openStatuses($event)"
                    >
                        <nz-option *ngFor="let option of displayedStatuses; trackBy: trackChoice"
                            [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
                    </nz-select>
                    <span *ngIf="statusOptions.error" class="task-browser__filter-error" role="alert">
                        {{ statusOptions.error }}
                        <button nz-button nzType="link" type="button" (click)="openStatuses(true)">Retry</button>
                    </span>
                </div>
            </div>
            <nz-select *ngIf="filtersVisible && isCombinedHeader"
                id="task-browser-item-type"
                class="task-browser__item-type"
                aria-label="Show assigned work type"
                nzSize="small"
                [ngModel]="state.combinedHeader?.filters?.itemType || 'all'"
                (ngModelChange)="changeItemType($event)">
                <nz-option nzValue="all" nzLabel="All"></nz-option>
                <nz-option nzValue="task" nzLabel="Tasks"></nz-option>
                <nz-option nzValue="evidence" nzLabel="Evidence"></nz-option>
            </nz-select>
            <nz-select *ngIf="filtersVisible && !isCombinedHeader"
                id="task-browser-sort"
                aria-label="Sort tasks"
                class="task-browser__sort"
                nzSize="small"
                [ngModel]="state.filters.sort || 'due_date_desc'"
                (ngModelChange)="changeSort($event)"
                [nzCustomTemplate]="sortSelectionTpl">
                <nz-option *ngFor="let option of sortOptions"
                    [nzValue]="option.value" [nzLabel]="option.accessibleLabel" nzCustomContent>
                    <span [attr.aria-label]="option.accessibleLabel">
                        {{ option.label }} <span nz-icon [nzType]="option.icon" aria-hidden="true"></span>
                    </span>
                </nz-option>
            </nz-select>
            <ng-template #sortSelectionTpl let-selected>
                <ng-container *ngFor="let option of sortOptions">
                    <span *ngIf="option.value === selected.nzValue" [attr.aria-label]="option.accessibleLabel">
                        {{ option.label }} <span nz-icon [nzType]="option.icon" aria-hidden="true"></span>
                    </span>
                </ng-container>
            </ng-template>
            <div class="task-browser__scope" [attr.aria-label]="isCombinedHeader ? 'Assigned work actions' : 'Task actions'">
                <button *ngIf="!filtersVisible" class="cb4-button" nz-button nzType="link" type="button"
                    (click)="showFilters()"><span nz-icon nzType="search"></span>
                    {{ isCombinedHeader ? 'Search/Filter' : 'Search/Filter/Sort' }}</button>
                <button *ngIf="canOfferTaskCreation" nz-button nzType="primary" nzSize="small" type="button" class="task-browser__add-button cb4-button"
                    (click)="addTask()"><i nz-icon nzType="plus" aria-hidden="true"></i> Add Task</button>
            </div>
            </div>

            <div *ngIf="state.filters.requirement" class="task-browser__scope" aria-label="Current task scope">
                <button *ngIf="state.filters.taskId" nz-button nzType="default" type="button"
                    (click)="removeTaskSelector()" [attr.aria-label]="'Remove task ' + state.filters.taskId + ' filter'">
                    Task #{{ state.filters.taskId }} <span aria-hidden="true">×</span>
                </button>
                <button *ngIf="state.filters.requirement as requirement" nz-button nzType="default" type="button"
                    (click)="removeRequirementSelector()" aria-label="Remove requirement filter">
                    {{ requirement.sectionKey }} · {{ requirement.requirementKey }} <span aria-hidden="true">×</span>
                </button>
            </div>

            <div *ngIf="navigationError" class="task-browser__navigation-error">
                <span role="alert">{{ navigationError }} Assessment and requirement labels are shown without links.</span>
                <button nz-button nzType="link" type="button" (click)="retryNavigation()">Retry</button>
            </div>

            </ng-container>

            <div *ngIf="activeLoading" class="task-browser__feedback task-browser__feedback--loading" aria-busy="true">
                <app-loading-indicator [message]="isCombinedHeader ? 'Loading assigned work...' : 'Loading tasks...'"></app-loading-indicator>
            </div>

            <div *ngIf="!activeLoading && activeError" class="task-browser__feedback">
                <nz-alert nzType="error" [nzMessage]="activeError" nzShowIcon></nz-alert>
                <button nz-button nzType="default" type="button" (click)="retry()">Retry</button>
            </div>

            <p *ngIf="!activeLoading && !activeError && activeItemCount === 0"
               class="task-browser__feedback" role="status">
                {{ emptyMessage }}
            </p>

            <ng-container *ngIf="!activeError && activeItemCount > 0">
                <div class="task-browser__list" [style.display]="activeLoading ? 'none' : null">
                    <ng-container *ngFor="let item of visibleRows; trackBy: trackWorkItem">
                    <article *ngIf="item.task as task; else evidenceCard" class="task-browser__card"
                        [class.task-browser__card--selected]="state.filters.taskId === task.id">
                        <div class="task-browser__heading">
                            <div>
                                <span class="task-browser__label">Task Description:</span>
                                <p class="task-browser__assessment task-browser__heading-description">{{ task.description }}</p>
                            </div>
                            <div class="task-browser__heading-actions">
                                <nz-tag class="task-browser__heading-status" [nzColor]="statusPresentation(task.status).tagColor">
                                    {{ statusPresentation(task.status).label }}
                                </nz-tag>
                                <div class="task-browser__heading-icon-actions">
                                <button *ngIf="task.capabilities.canEditTask || task.capabilities.canChangeStatus" nz-button nzType="default" nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Edit" class="task-browser__icon-button task-browser__icon-button--edit"
                                    type="button" [disabled]="taskWritePending(task.id)"
                                    (click)="editTask(task)"
                                    [attr.aria-label]="'Edit task ' + task.id">
                                    <i nz-icon nzType="edit" aria-hidden="true"></i>
                                </button>
                                <button *ngIf="task.capabilities.canDeleteTask" nz-button nzType="default" nzShape="circle" nzDanger nzSize="small" nz-tooltip nzTooltipTitle="Delete" class="task-browser__icon-button task-browser__icon-button--delete"
                                    type="button" [disabled]="taskWritePending(task.id) || !!deleteErrors.get(task.id)?.conflict"
                                    (click)="confirmDeleteTask(task)"
                                    [attr.aria-label]="'Delete task ' + task.id">
                                    <i nz-icon nzType="delete" aria-hidden="true"></i>
                                </button>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="deleteErrors.get(task.id) as deleteError" class="task-browser__status-error" role="alert">
                            <span>{{ deleteError.message }}</span>
                            <button nz-button nzType="link" type="button" nzSize="small" (click)="reloadStatusTask()">Reload</button>
                        </div>

                        <p *ngIf="state.context?.kind !== 'assessment'" class="task-browser__assessment">
                            <strong>Assessment:</strong>
                            <a *ngIf="assessmentLinks.get(task.productLicenseId) as route; else unavailableAssessmentTpl"
                                [routerLink]="route" (click)="close()">
                                {{ task.assessmentLabel }}
                            </a>
                            <ng-template #unavailableAssessmentTpl>
                                <span [title]="'Assessment navigation is unavailable for this task'">
                                    {{ task.assessmentLabel }}
                                </span>
                            </ng-template>
                        </p>

                        <div *ngIf="task.requirements.length > 0" class="task-browser__requirements" role="group" aria-label="Assigned Controls">
                            <span class="task-browser__label">Assigned Controls:</span>
                            <span *ngFor="let requirement of task.requirements" class="task-browser__requirement">
                                <a *ngIf="requirementLinks.get(requirementLinkKey(task, requirement)) as route; else unavailableRequirementTpl"
                                    [routerLink]="route" (click)="close()"
                                    [attr.aria-label]="'Open ' + requirement.sectionLabel + ' ' + requirement.requirementLabel">
                                    {{ requirement.sectionLabel }} · {{ requirement.requirementLabel }}
                                </a>
                                <ng-template #unavailableRequirementTpl>
                                    <span [title]="'Assessment navigation is unavailable for this task'">
                                        {{ requirement.sectionLabel }} · {{ requirement.requirementLabel }}
                                    </span>
                                </ng-template>
                            </span>
                        </div>

                        <div class="task-browser__details">
                            <p><span class="task-browser__label">Created by:</span> {{ task.creator?.displayName || 'Former user' }}</p>
                            <p><span class="task-browser__label">Last updated:</span> {{ formatDateTime(task.updatedAt) }}</p>
                            <p *ngIf="task.dueDate" [class.task-browser__due--overdue]="dueState(task.dueDate, task.status) === 'overdue'"
                                    [class.text-danger]="dueState(task.dueDate, task.status) === 'overdue'"
                               [class.task-browser__due--soon]="dueState(task.dueDate, task.status) === 'due_soon'"
                               [class.text-warning]="dueState(task.dueDate, task.status) === 'due_soon'">
                                <span class="task-browser__label task-browser__due-label">Due:&nbsp;</span><time [attr.datetime]="task.dueDate">{{ task.dueDate | date: 'd MMMM yyyy' }}</time>
                            </p>
                        </div>

                        <div class="task-browser__assignees">
                            <span class="task-browser__label">Assigned to:</span>
                            <span *ngIf="task.assignees.length === 0">No current assignees</span>
                            <span *ngFor="let assignee of task.assignees" class="task-browser__assignee">
                                {{ assignee.displayName }}
                                <small *ngIf="assignee.assignedAt">
                                    assigned {{ assignee.assignedAt | date: 'd MMM yyyy' }}
                                    <span *ngIf="assignee.assignedBy">by {{ assignee.assignedBy.displayName }}</span>
                                </small>
                            </span>
                        </div>

                        <app-work-item-comments [taskItem]="task" [busy]="deleteRequestsPending(task.id)" (pendingChange)="setCommentPending(task.id, $event)"></app-work-item-comments>
                    </article>
                    <ng-template #evidenceCard>
                    <app-evidence-work-item-card *ngIf="item.evidence as evidence"
                        [evidence]="evidence" [mutationPending]="taskWritePending(evidenceCommentTarget(evidence).id)" [assessmentRoute]="assessmentLinks.get(evidence.productLicenseId) || null"
                        (edit)="openEvidence(evidence, 'edit')" (delete)="openEvidence(evidence, 'delete')"
                        (email)="openEvidence(evidence, 'email')" (upload)="openEvidenceFileAction(evidence, 'upload')"
                        (linkedFile)="openEvidenceFileAction(evidence, $event)" (navigate)="close()">
                        <app-work-item-comments [evidence]="evidence" (pendingChange)="setCommentPending(evidenceCommentTarget(evidence).id, $event)"></app-work-item-comments>
                    </app-evidence-work-item-card>
                    </ng-template>
                    </ng-container>
                </div>

                <nz-pagination
                    *ngIf="!state.filters.taskId && activeTotal > (activeFilters.pageSize || 25)"
                    class="task-browser__pagination"
                    [nzPageIndex]="activeFilters.page || 1"
                    [nzPageSize]="activeFilters.pageSize || 25"
                    [nzTotal]="activeTotal"
                    [nzShowSizeChanger]="false"
                    (nzPageIndexChange)="changePage($event)"
                ></nz-pagination>
            </ng-container>
        </div>
    </ng-container>
</nz-modal>
